import { Injectable } from '@angular/core'
import { getMonthOptions } from './common.service'

@Injectable({
  providedIn: 'root'
})
export class SummaryTableService {
  constructor() {}

  buildViewForOption() {
    const options = getMonthOptions()
    options.unshift({
      key: undefined,
      value: 'ALL'
    })
    return options
  }

  buildEmptyCreatedatetimeFilterIfValueIsNull(value: string) {
    if (!value) {
      return { createdDatetimeRange: null }
    }
    const daterange = value.split('^')
    return { createdDatetimeRange: { begin: new Date(daterange[0]), end: new Date(daterange[1]) } }
  }
}
